import { CommandType } from "~app/common/services/cqs/CommandType";
import { ProduktionsmallBaseCommand } from "~app/features/planera/commands/ProduktionsmallBaseCommand";

export class UpdateProduktionsmallCommand extends ProduktionsmallBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateProduktionsmallCommand";

    constructor(guid: string, benamning: string, vardekap: boolean, ckLeverantorId?: number) {
        super(UpdateProduktionsmallCommand.$type, CommandType.Replace);
        this.guid = guid;
        this.benamning = benamning;
        this.vardekap = vardekap;
        this.ckLeverantorId = ckLeverantorId;
    }
}
